var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "navbar navbar-header navbar-header-fixed" },
    [
      _c(
        "a",
        { staticClass: "burger-menu", attrs: { href: "", id: "mainMenuOpen" } },
        [_c("feather", { attrs: { type: "menu" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "navbar-brand" },
        [
          _c(
            "router-link",
            { staticClass: "df-logo", attrs: { to: { name: "main" } } },
            [_vm._v("Accu"), _c("span", [_vm._v("LIMS")])]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "navbar-menu-wrapper", attrs: { id: "navbarMenu" } },
        [
          _c("div", { staticClass: "navbar-menu-header" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { id: "mainMenuClose", href: "" } },
              [_c("feather", { attrs: { type: "x" } })],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-header" }, [
            _c("h5", [_vm._v("Search")]),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "", id: "sidebarMenuOpen" } },
              [_c("feather", { attrs: { type: "search" } })],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "nav navbar-menu mw-100" },
            [
              _c(
                "li",
                { staticClass: "nav-label pd-l-15 pd-lg-l-25 d-lg-none" },
                [_vm._v("Main Navigation")]
              ),
              _vm._v(" "),
              _vm._l(_vm.menuHeaders, function(menuHeader) {
                return _c(
                  "li",
                  {
                    staticClass: "nav-item with-sub",
                    on: {
                      click: function($event) {
                        return _vm.menuClick()
                      }
                    }
                  },
                  [
                    _c("a", { staticClass: "nav-link", attrs: { href: "#" } }, [
                      _vm._v(_vm._s(menuHeader.mains))
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "navbar-menu-sub" },
                      _vm._l(menuHeader.subs, function(submenu) {
                        return _c(
                          "li",
                          { key: submenu.id, staticClass: "nav-sub-item" },
                          [
                            submenu.menuName !== "Sample List"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "nav-sub-link",
                                    on: {
                                      click: function($event) {
                                        return _vm.goMenu(
                                          submenu.menuRoute,
                                          submenu.id,
                                          submenu
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(submenu.menuName))]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "navbar-right" }, [
        _c("div", { staticClass: "dropdown dropdown-message" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-link new-indicator",
              attrs: { href: "", "data-toggle": "dropdown" }
            },
            [
              _c("feather", { attrs: { type: "message-square" } }),
              this.totalRead != 0
                ? _c("span", [_vm._v(_vm._s(_vm.totalRead))])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-menu dropdown-menu-right" },
            [
              _vm._l(_vm.pushData, function(form, i) {
                return _c(
                  "div",
                  { staticClass: "dropdown-header" },
                  [
                    [
                      _c(
                        "b-taglist",
                        { attrs: { attached: "" } },
                        [
                          _c("b-tag", { attrs: { type: "is-dark" } }, [
                            _vm._v(_vm._s(form.type))
                          ]),
                          _vm._v(" "),
                          form.type == "Message"
                            ? _c("b-tag", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      id: "chatModal",
                                      href: "#modal99",
                                      "data-toggle": "modal"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.chatModal(form.refId)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(form.receptionNo))]
                                )
                              ])
                            : form.type == "Approval"
                            ? _c("b-tag", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        return _vm.approvalExp(form)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(form.experimentNo))]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("b-tag", { attrs: { type: "is-info" } }, [
                            _vm._v(_vm._s(form.read))
                          ])
                        ],
                        1
                      )
                    ]
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-footer" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.viewAllMessage()
                      }
                    }
                  },
                  [_vm._v("Read All")]
                )
              ])
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown dropdown-profile" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-link a-black",
              attrs: {
                href: "",
                "data-toggle": "dropdown",
                "data-display": "static"
              }
            },
            [
              _c(
                "div",
                { staticClass: "avatar avatar-sm" },
                [_c("feather", { attrs: { type: "user" } })],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-menu dropdown-menu-right" }, [
            _c("h6", { staticClass: "tx-semibold mg-b-5" }, [
              _vm._v(_vm._s(_vm.userHeaders.companyName))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mg-b-25 tx-12 tx-color-03" }, [
              _vm._v(_vm._s(_vm.userHeaders.userName))
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "dropdown-item",
                on: {
                  click: function($event) {
                    _vm.isComponentModalActive = true
                  }
                }
              },
              [
                _c("feather", { attrs: { type: "edit-3" } }),
                _vm._v(" Edit Password")
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "dropdown-item",
                attrs: { href: "" },
                on: { click: _vm.logout }
              },
              [
                _c("feather", { attrs: { type: "log-out" } }),
                _vm._v("Sign Out")
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "modal99",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel99",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("HeaderChat")], 1)
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isComponentModalActive,
            "has-modal-card": "",
            "trap-focus": "",
            "aria-role": "dialog",
            "aria-modal": ""
          },
          on: {
            "update:active": function($event) {
              _vm.isComponentModalActive = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-card", staticStyle: { width: "250px" } },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v("Edit Password")
                ])
              ]),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Password" } },
                    [
                      _c("b-input", {
                        ref: "password",
                        attrs: {
                          type: "password",
                          id: "password",
                          "password-reveal": "",
                          placeholder: "Your password",
                          required: ""
                        },
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password = $$v
                          },
                          expression: "password"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-field",
                    { attrs: { label: "Confirm Password" } },
                    [
                      _c("b-input", {
                        ref: "cpassword",
                        attrs: {
                          type: "password",
                          id: "cpassword",
                          "password-reveal": "",
                          placeholder: "Your password",
                          required: ""
                        },
                        model: {
                          value: _vm.cpassword,
                          callback: function($$v) {
                            _vm.cpassword = $$v
                          },
                          expression: "cpassword"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.initialPwd()
                      }
                    }
                  },
                  [_vm._v("Close")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    on: { click: _vm.editPass }
                  },
                  [_vm._v("Edit")]
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "df-logo", attrs: { href: "" } }, [
      _vm._v("Accu"),
      _c("span", [_vm._v("LIMS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel5" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46e661f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46e661f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Common/Header.vue
// module id = null
// module chunks = 